import { Routes } from '@angular/router';
import { canActivateAdmin, canActivateUser } from '@shs-digi-care-monorepo/frontend-lib/auth';
import { PendingRequestsComponent } from '@shs-digi-care-monorepo/frontend-lib/components/pending-requests/pending-requests.component';

export const APP_ROUTES: Routes = [
    {
        path: '',
        pathMatch: 'full',
        loadComponent: () => import('./menu/menu.component').then((m) => m.MenuComponent)
    },
    {
        path: 'request',
        loadComponent: () => import('./request/request.component').then((m) => m.RequestComponent)
    },
    {
        path: 'request/:id',
        loadComponent: () => import('./request-detail/request-detail.component').then((m) => m.RequestDetailComponent)
    },
    {
        path: 'requests',
        loadComponent: () => import('./requests/tasks.component').then((m) => m.TasksComponent),
        data: { mode: 'requests' }
    },
    {
        path: 'tasks',
        loadComponent: () => import('./requests/tasks.component').then((m) => m.TasksComponent),
        data: { mode: 'tasks' }
    },
    {
        path: 'admin',
        loadChildren: () => import('./admin/admin.routes').then((m) => m.ADMIN_ROUTES),
        canActivate: [canActivateUser, canActivateAdmin]
    },
    {
        path: 'settings',
        loadChildren: () => import('./settings/settings.routes').then((m) => m.SETTINGS_ROUTES),
        canActivate: [canActivateUser]
    },
    {
        path: 'escalation/pending-requests',
        component: PendingRequestsComponent
    },
    {
        path: '**',
        redirectTo: ''
    }
];
